<form [formGroup]="specialInstructionForm">
  <div class="field p-fluid">
    <label data-test-id="special-instructions-label">Enter Special Instructions:</label>
    <textarea
      pInputTextarea
      formControlName="comment"
      maxlength="3000"
      class="resize-y w-full"
      [cols]="80"
      [rows]="4"
      [autoResize]="true"
      [readOnly]="isExternalUser || !hasEditablePermission"
      data-test-id="special-instructions-textarea" 
    ></textarea>
  </div>
  @if (!isExternalUser && hasEditablePermission) {
    <div class="flex justify-end">
      <button
        pButton
        type="button"
        label="Save Instructions"
        class="p-button-action"
        (click)="saveSpecialInstructions()"
        [disabled]="!saveEnabled || specialInstructionForm.invalid || isLoadingData"
        data-test-id="special-instructions-save-button"
      ></button>
    </div>
  }
</form>
